import Icon from '@material-ui/icons/Bookmark';
import React from 'react';
import { CreateButton } from '../../../buttons';
import { Filter, NestedResourceList, ResourceList, ResourceShow } from '../../../controllers';
import { LinkField, TextField } from '../../../fields';
import { BooleanInput, SearchInput, TextInput } from '../../../inputs';
import library_object_constant_values from './library_object_constant_values';

export default {
  Icon,
  dialogs: {
    create: props => (
      <CreateButton
        fixedValue={{ library_object_id: props.parentResource.id }}
        {...props}
      >
        <TextInput
          source="name"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="name"
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="name"
        />
        <NestedResourceList
          reference="library_object_constant_values"
        >
          <TextField
            source="value"
          />
          <LinkField
            source="library_keyring_id"
            allowEmpty
          />
        </NestedResourceList>
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
    library_object_constant_values,
  },
};
